import {BaseApiRequestParams} from "./base-api-request-params";

export class UrlRequestParams extends BaseApiRequestParams {
  get fullUrl(): String {
    return this.baseUrl;
  }
}
